module.exports = __webpack_public_path__ + "img/AhmadRahadian-nologo.9dde627f.png";